import React from 'react'
import styled from 'styled-components'
import { Text } from 'toonswap-uikit'

export interface PoolCellProps {
  label: string
  sousId: number
  earningSymbol: string
  stakingSymbol: string
  isFinished?: boolean
}

const IconImage = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 25px;
  width: 46px;
  height: 46px;

  .earningIcon {
    position: relative;
    z-index: 2;
    border-radius: 50%;
    width: 46px;
    height: 46px;
    object-fit: cover;
  }

  .stakingIcon {
    position: absolute;
    right: -15px;
    bottom: -2px;
    z-index: 3;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    object-fit: cover;
    border: 2px solid #374244;
  }
`

const Container = styled.div`
  padding-left: 16px;
  display: flex;
  align-items: center;
`

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const PoolCell: React.FC<PoolCellProps> = ({ label, earningSymbol, stakingSymbol }) => {
  return (
    <Container>
      <IconImage>
        <img
          className="earningIcon"
          src={`/images/pools/${earningSymbol.toLowerCase()}.png`}
          alt={label}
          onError={(e) => {
            e.currentTarget.src = '/images/cookie.png'
          }}
        />
        <img
          className="stakingIcon"
          src={`/images/pools/${stakingSymbol.toLowerCase()}.png`}
          alt={label}
          onError={(e) => {
            e.currentTarget.src = '/images/cookie.png'
          }}
        />
      </IconImage>
      <LabelWrapper>
        <Text bold fontSize="18px" color="#ffffff97">
          {label}
        </Text>
        <Text fontSize="12px" color="#ffffff75">
          Stake {stakingSymbol}
        </Text>
      </LabelWrapper>
    </Container>
  )
}

export default PoolCell
